import { E as q, g as H, u as wr, s as w, j as X, G as z, d as Or, _ as g, b as R, q as Pr, a1 as C, f as Z, v as Ir, n as Hr, a0 as rr, V as Xr, a2 as zr, c as Zr, J as re, X as ee, e as te, k as ae, a3 as oe, U as ne, I as Tr, o as ie, w as Er, R as se, C as er, F as ve, t as ue, a4 as le } from "./export-cdcbfb2b.js";
import { t as N } from "./to-string-92a62764.js";
import { o as fe, a as ce } from "./object-create-9b6715a2.js";
import { o as ye } from "./object-keys-719a5561.js";
import { o as pe } from "./object-get-own-property-names-external-2f8b4cc4.js";
import { d as Dr } from "./define-built-in-accessor-26bc7b69.js";
import { s as be } from "./iterate-13ada9e5.js";
import { a as me, i as de } from "./array-iteration-759bfbfa.js";
import { f as ge } from "./function-apply-4756dee6.js";
import { a as Se } from "./array-slice-79f93c56.js";
var tr = {}, $e = q;
tr.f = $e;
var he = H, we = he, sr = we, Oe = w, Pe = tr, Ie = wr.f, Te = function(t) {
  var r = sr.Symbol || (sr.Symbol = {});
  Oe(r, t) || Ie(r, t, {
    value: Pe.f(t)
  });
}, Ee = X, De = z, je = q, Re = Or, Ce = function() {
  var t = De("Symbol"), r = t && t.prototype, e = r && r.valueOf, a = je("toPrimitive");
  r && !r[a] && Re(r, a, function(o) {
    return Ee(e, this);
  }, { arity: 1 });
}, B = g, O = H, ar = X, Ne = R, b = Pr, m = C, Be = Z, i = w, Fe = Ir, k = ae, F = Zr, or = oe, _e = N, J = ne, d = fe, jr = ye, Ke = Hr, Rr = pe, Me = Tr, Cr = ie, Nr = wr, Le = ce, Br = re, x = Or, Ye = Dr, nr = rr, xe = Xr, Fr = ee, vr = zr, Ae = q, Ge = tr, Ve = Te, ke = Ce, Je = be, _r = te, _ = me.forEach, s = xe("hidden"), K = "Symbol", h = "prototype", Ue = _r.set, ur = _r.getterFor(K), v = Object[h], y = O.Symbol, $ = y && y[h], We = O.RangeError, Qe = O.TypeError, A = O.QObject, Kr = Cr.f, p = Nr.f, Mr = Rr.f, qe = Br.f, Lr = Ne([].push), l = nr("symbols"), P = nr("op-symbols"), He = nr("wks"), U = !A || !A[h] || !A[h].findChild, Yr = function(t, r, e) {
  var a = Kr(v, r);
  a && delete v[r], p(t, r, e), a && t !== v && p(v, r, a);
}, W = b && Be(function() {
  return d(p({}, "a", {
    get: function() {
      return p(this, "a", { value: 7 }).a;
    }
  })).a !== 7;
}) ? Yr : p, G = function(t, r) {
  var e = l[t] = d($);
  return Ue(e, {
    type: K,
    tag: t,
    description: r
  }), b || (e.description = r), e;
}, M = function(r, e, a) {
  r === v && M(P, e, a), k(r);
  var o = or(e);
  return k(a), i(l, o) ? (a.enumerable ? (i(r, s) && r[s][o] && (r[s][o] = !1), a = d(a, { enumerable: J(0, !1) })) : (i(r, s) || p(r, s, J(1, d(null))), r[s][o] = !0), W(r, o, a)) : p(r, o, a);
}, ir = function(r, e) {
  k(r);
  var a = F(e), o = jr(a).concat(Gr(a));
  return _(o, function(n) {
    (!b || ar(Q, a, n)) && M(r, n, a[n]);
  }), r;
}, Xe = function(r, e) {
  return e === void 0 ? d(r) : ir(d(r), e);
}, Q = function(r) {
  var e = or(r), a = ar(qe, this, e);
  return this === v && i(l, e) && !i(P, e) ? !1 : a || !i(this, e) || !i(l, e) || i(this, s) && this[s][e] ? a : !0;
}, xr = function(r, e) {
  var a = F(r), o = or(e);
  if (!(a === v && i(l, o) && !i(P, o))) {
    var n = Kr(a, o);
    return n && i(l, o) && !(i(a, s) && a[s][o]) && (n.enumerable = !0), n;
  }
}, Ar = function(r) {
  var e = Mr(F(r)), a = [];
  return _(e, function(o) {
    !i(l, o) && !i(Fr, o) && Lr(a, o);
  }), a;
}, Gr = function(t) {
  var r = t === v, e = Mr(r ? P : F(t)), a = [];
  return _(e, function(o) {
    i(l, o) && (!r || i(v, o)) && Lr(a, l[o]);
  }), a;
};
m || (y = function() {
  if (Fe($, this))
    throw new Qe("Symbol is not a constructor");
  var r = !arguments.length || arguments[0] === void 0 ? void 0 : _e(arguments[0]), e = vr(r), a = function(o) {
    var n = this === void 0 ? O : this;
    n === v && ar(a, P, o), i(n, s) && i(n[s], e) && (n[s][e] = !1);
    var S = J(1, o);
    try {
      W(n, e, S);
    } catch (T) {
      if (!(T instanceof We))
        throw T;
      Yr(n, e, S);
    }
  };
  return b && U && W(v, e, { configurable: !0, set: a }), G(e, r);
}, $ = y[h], x($, "toString", function() {
  return ur(this).tag;
}), x(y, "withoutSetter", function(t) {
  return G(vr(t), t);
}), Br.f = Q, Nr.f = M, Le.f = ir, Cr.f = xr, Ke.f = Rr.f = Ar, Me.f = Gr, Ge.f = function(t) {
  return G(Ae(t), t);
}, b && (Ye($, "description", {
  configurable: !0,
  get: function() {
    return ur(this).description;
  }
}), x(v, "propertyIsEnumerable", Q, { unsafe: !0 })));
B({ global: !0, constructor: !0, wrap: !0, forced: !m, sham: !m }, {
  Symbol: y
});
_(jr(He), function(t) {
  Ve(t);
});
B({ target: K, stat: !0, forced: !m }, {
  useSetter: function() {
    U = !0;
  },
  useSimple: function() {
    U = !1;
  }
});
B({ target: "Object", stat: !0, forced: !m, sham: !b }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: Xe,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: M,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: ir,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: xr
});
B({ target: "Object", stat: !0, forced: !m }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: Ar
});
ke();
Je(y, K);
Fr[s] = !0;
var ze = C, Vr = ze && !!Symbol.for && !!Symbol.keyFor, Ze = g, rt = z, et = w, tt = N, kr = rr, at = Vr, V = kr("string-to-symbol-registry"), ot = kr("symbol-to-string-registry");
Ze({ target: "Symbol", stat: !0, forced: !at }, {
  for: function(t) {
    var r = tt(t);
    if (et(V, r))
      return V[r];
    var e = rt("Symbol")(r);
    return V[r] = e, ot[e] = r, e;
  }
});
var nt = g, it = w, st = Er, vt = se, ut = rr, lt = Vr, lr = ut("symbol-to-string-registry");
nt({ target: "Symbol", stat: !0, forced: !lt }, {
  keyFor: function(r) {
    if (!st(r))
      throw new TypeError(vt(r) + " is not a symbol");
    if (it(lr, r))
      return lr[r];
  }
});
var ft = R, fr = de, ct = er, cr = ve, yt = N, yr = ft([].push), pt = function(t) {
  if (ct(t))
    return t;
  if (fr(t)) {
    for (var r = t.length, e = [], a = 0; a < r; a++) {
      var o = t[a];
      typeof o == "string" ? yr(e, o) : (typeof o == "number" || cr(o) === "Number" || cr(o) === "String") && yr(e, yt(o));
    }
    var n = e.length, S = !0;
    return function(T, L) {
      if (S)
        return S = !1, L;
      if (fr(this))
        return L;
      for (var Y = 0; Y < n; Y++)
        if (e[Y] === T)
          return L;
    };
  }
}, bt = g, Jr = z, Ur = ge, mt = X, I = R, Wr = Z, pr = er, br = Er, Qr = Se, dt = pt, gt = C, St = String, f = Jr("JSON", "stringify"), E = I(/./.exec), mr = I("".charAt), $t = I("".charCodeAt), ht = I("".replace), wt = I(1 .toString), Ot = /[\uD800-\uDFFF]/g, dr = /^[\uD800-\uDBFF]$/, gr = /^[\uDC00-\uDFFF]$/, Sr = !gt || Wr(function() {
  var t = Jr("Symbol")("stringify detection");
  return f([t]) !== "[null]" || f({ a: t }) !== "{}" || f(Object(t)) !== "{}";
}), $r = Wr(function() {
  return f("\uDF06\uD834") !== '"\\udf06\\ud834"' || f("\uDEAD") !== '"\\udead"';
}), Pt = function(t, r) {
  var e = Qr(arguments), a = dt(r);
  if (!(!pr(a) && (t === void 0 || br(t))))
    return e[1] = function(o, n) {
      if (pr(a) && (n = mt(a, this, St(o), n)), !br(n))
        return n;
    }, Ur(f, null, e);
}, It = function(t, r, e) {
  var a = mr(e, r - 1), o = mr(e, r + 1);
  return E(dr, t) && !E(gr, o) || E(gr, t) && !E(dr, a) ? "\\u" + wt($t(t, 0), 16) : t;
};
f && bt({ target: "JSON", stat: !0, arity: 3, forced: Sr || $r }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  stringify: function(r, e, a) {
    var o = Qr(arguments), n = Ur(Sr ? Pt : f, null, o);
    return $r && typeof n == "string" ? ht(n, Ot, It) : n;
  }
});
var Tt = g, Et = C, Dt = Z, qr = Tr, jt = ue, Rt = !Et || Dt(function() {
  qr.f(1);
});
Tt({ target: "Object", stat: !0, forced: Rt }, {
  getOwnPropertySymbols: function(r) {
    var e = qr.f;
    return e ? e(jt(r)) : [];
  }
});
var Ct = g, Nt = Pr, Bt = H, D = R, Ft = w, _t = er, Kt = Ir, Mt = N, Lt = Dr, Yt = le, u = Bt.Symbol, c = u && u.prototype;
if (Nt && _t(u) && (!("description" in c) || // Safari 12 bug
u().description !== void 0)) {
  var hr = {}, j = function() {
    var r = arguments.length < 1 || arguments[0] === void 0 ? void 0 : Mt(arguments[0]), e = Kt(c, this) ? new u(r) : r === void 0 ? u() : u(r);
    return r === "" && (hr[e] = !0), e;
  };
  Yt(j, u), j.prototype = c, c.constructor = j;
  var xt = String(u("description detection")) === "Symbol(description detection)", At = D(c.valueOf), Gt = D(c.toString), Vt = /^Symbol\((.*)\)[^)]+$/, kt = D("".replace), Jt = D("".slice);
  Lt(c, "description", {
    configurable: !0,
    get: function() {
      var r = At(this);
      if (Ft(hr, r))
        return "";
      var e = Gt(r), a = xt ? Jt(e, 7, -1) : kt(e, Vt, "$1");
      return a === "" ? void 0 : a;
    }
  }), Ct({ global: !0, constructor: !0, forced: !0 }, {
    Symbol: j
  });
}
export {
  we as p,
  Te as w
};
